import { FONT_SIZE, COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivTagFlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SpanText = styled.span`
  font-size: 14px;
  line-height: 1;
  margin: 0 8px;
  ${mq.sp} {
    font-size: 12px;
  }
`;

export const DivPurchaseFlex = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const BtnPurchase = styled.button`
  margin-left: 8px;
  width: fit-content;
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.BLUE900.code};

  @media (any-hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }

  ${mq.sp} {
    margin-left: 4px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;
